export const COOKIE_PATH_KEY = "sph-epaper-cookie-path";

/**
 * Extracts the first path segment from the current URL and saves it to local storage.
 *
 * If the current URL does not contain any paths, an error is thrown.
 */
export const saveCookiePath = () => {
  const currentUrlPath = new URL(window.location.href).pathname;
  const split = currentUrlPath.split("/");

  if (split.length < 2 || split[1] === "") {
    console.error(
      "Cannot extract cookie path from current URL - URL has no path segments.",
    );
  }

  const cookiePath = `/${split[1]}`;
  localStorage.setItem(COOKIE_PATH_KEY, cookiePath);
};


